<!-- 2 columns form -->
<form name="awardform" [formGroup]="awardForm" novalidate>
  <div class="panel panel-flat">
    <div class="panel-heading">
      <h5 class="panel-title">Add Award</h5>
      <div class="heading-elements">
        <ul class="icons-list">
          <li>
            <a data-action="reload" ng-click="mainService.reload()"></a>
          </li>
        </ul>
      </div>
      <hr class="divider">
    </div>

    <div class="panel-body">

      <div class="row">
        <div class="col-md-6">
          <fieldset>
            <legend class="text-semibold">
              <i class="icon-reading position-left"></i> Award Specs
            </legend>
            <div class="col-md-6">
              <div class="form-group required">
                <span class="control-label"> Equb: </span>
                <ng-select [items]="ekubs" placeholder="" (change)="getEkubMembers()" formControlName="ekub"
                  bindValue="id" bindLabel="text" required>
                </ng-select>
                <div class="help-block" *ngIf="ekub.invalid && (ekub.dirty && ekub.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 position-left"></i> Equb is required
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <span class="control-label">Winner: </span>
                <ng-select [items]="ekubMembers" [readonly]="isOperationAdd()" placeholder="Award winner"
                  formControlName="winner" bindValue="id" bindLabel="username">
                </ng-select>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group required">
                <span class="control-label">Award Draw Date: </span>
                <input type="date" name="draw_date" formControlName="draw_date" required
                  placeholder="award drawing date" class="form-control">
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <span class="control-label">Award Draw Time: </span>
                <input type="time" name="draw_time" formControlName="draw_time" required
                  placeholder="award drawing time" class="form-control">
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <span class="control-label">Award recieve Date: </span>
                <input type="date" name="recieved_date" formControlName="recieved_date"
                  placeholder="award recieved date" class="form-control">
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <span class="control-label">Amount: </span>
                <input type="number" name="amount" formControlName="amount" placeholder="award amount"
                  class="form-control">
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group required">
                <span class="control-label">Status: </span>
                <select name="status" required formControlName="status" class="form-control"
                  data-placeholder="Select award status">
                  <option selected disabled>Status:</option>
                  <option value="pending">Pending</option>
                  <option value="drawed">Drawed</option>
                  <option value="scheduled">Scheduled</option>
                  <option value="initialized">Initialized</option>
                  <option value="sold">Sold</option>
                </select>
                <div class="help-block" *ngIf="status.invalid && (status.dirty || status.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 position-left"></i>Award status is required.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group">
                <label>&nbsp;</label>
                <label>Remark:</label>
                <textarea rows="5" cols="5" class="form-control" name="remark" formControlName="remark"
                  placeholder="Additional information . . ."></textarea>
                <div class="help-block" *ngIf="remark.invalid && (remark.dirty || remark.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 position-left"></i>Please write small description about the award
                  </p>
                </div>
              </div>
            </div>



          </fieldset>
          <div class="row">
            <div class="text-right">
              <br>
              <!--  <button class="btn bg-slate-800" (click)="addNews(award.id)" type="submit" data-style="slide-right" [ladda]="isLoading" [disabled]="newsForm.invalid">
              <span *ngIf="!award.id">Save News</span>
              <span *ngIf="award.id">Update News</span>
              <i class="icon-floppy-disk position-right"></i>
            </button> -->
              <button class="btn bg-slate-800" (click)="addAward()" type="submit" data-style="slide-right"
                [disabled]="awardForm.invalid">
                <span *ngIf="operation=='add'">Save Award</span>
                <span *ngIf="operation!='add'">Update Award</span>
                <i class="icon-floppy-disk position-right"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <fieldset>
            <legend class="text-semibold">
              <span class="text-left"><i class="icon-camera position-left"></i> Guarantee Info</span>
              <label style="float: right;" class="form-check-label text-right">
                <input type="checkbox" class="form-check-input-styled" data-fouc checked="addUpdateGuarantee"
                  ngModel="addUpdateGuarantee" [ngModelOptions]="{standalone: true}" (change)="toggleGuaranteeChange()">
                Add/Update Guarantee
              </label>

            </legend>

            <div *ngIf="addUpdateGuarantee" class="row">
              <br>
              <br>
              <div class="table-responsive">
                <div class="btn-group pull-right">
                  <a data-toggle="modal" data-target="#guarantee_modal" type="button"
                    class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
                    <i class="icon-add position-left"></i> Add Guarantee</a>

                </div>
                <br>
                <br>
                <table class="table datatable-column-search-inputs">
                  <thead>
                    <tr>
                      <th>Guarantee</th>
                      <th>Equbs</th>
                      <th>Balance/Guarantee Amount</th>
                      <th>Status</th>
                      <th>Remark</th>
                      <th class="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let guarantee of guarantees; let i = index">
                      <td>{{guarantee.guarantee}}</td>
                      <td>{{guarantee.ekubs}}</td>
                      <td>{{guarantee.amount_guaranteed}}</td>
                      <td>
                        <span class="label label-block label-warning"
                          *ngIf="guarantee.status === 'Pending' || guarantee.status === 'pending'">{{guarantee.status}}</span>
                        <span class="label label-block label-primary"
                          *ngIf="guarantee.status === 'Active' || guarantee.status === 'active'">{{guarantee.status}}</span>
                        <span class="label label-block label-success"
                          *ngIf="guarantee.status === 'Released' || guarantee.status === 'released'">{{guarantee.status}}</span>
                      </td>
                      <td>{{guarantee.remark}}</td>
                      <td class="text-center">
                        <ul class="icons-list">
                          <li class="dropdown">
                            <a href="" class="dropdown-toggle" data-toggle="dropdown">
                              <i class="icon-menu9"></i>
                            </a>

                            <ul class="dropdown-menu dropdown-menu-right">
                              <li>
                                <a href="">
                                  <i class="icon-file-pdf"></i>Update</a>
                              </li>
                              <li>
                                <a (click)="removeGuarantee(i)">
                                  <i class="icon-cash"></i> Remove</a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!--  <h6 class="text-right text-primary text-semibold">Equb Amount:
                  {{selectedEqub?.total_reward|number:'1.2-2'}}
                  ETB</h6>
                <h6 class="text-right text-danger text-semibold">Total Equbs: {{totalEkubs}}</h6>
                <h6
                  [ngClass]="{'text-danger': totalGuaranteeAmount < selectedEkub?.total_reward, 'text-success': totalGuaranteeAmount >= selectedEkub?.total_reward }"
                  class="text-right text-danger text-bold">Total Balance: {{totalGuaranteeAmount|number:'1.2-2'}}
                  ETB</h6> -->
                <br>
                <br>
                <div class="row">
                  <div class="col-md-6"></div>
                  <div class="col-md-6">
                    <div class="table-responsive no-border">
                      <table class="table">
                        <tbody>
                          <tr>
                            <th>Equb Value:</th>
                            <td>
                              <h5 class="text-right text-primary text-bold">
                                {{selectedEkub?.value|number:'1.2-2'}}
                                ETB</h5>
                            </td>
                          </tr>
                          <tr>
                            <th>Winner Balance (Debt):</th>
                            <td>
                              <h5 class="text-right text-primary text-bold">
                                {{winnerBalance|number:'1.2-2'}}
                                ETB</h5>
                            </td>
                          </tr>
                          <tr>
                            <th>Equbs Count</th>
                            <td class="text-right">{{totalEkubs}}</td>
                          </tr>
                          <tr>
                            <th>Total Balance:</th>
                            <td class="text-right text-primary">
                              <h5
                                [ngClass]="{'text-danger': totalGuaranteeAmount + winnerBalance < 0, 'text-success': totalGuaranteeAmount + winnerBalance >= 0}"
                                class="text-right text-danger text-bold">{{totalGuaranteeAmount|number:'1.2-2'}} ETB
                              </h5>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>




          </fieldset>
        </div>

      </div>

      <div class="text-right" *ngIf="addUpdateGuarantee">
        <br>
        <button class="btn bg-slate-800" (click)="saveGuarantee()" type="submit" data-style="slide-right"
          [disabled]="checkValidity()">
          <span *ngIf="operation=='add'">Save Guarantee</span>
          <span *ngIf="operation!='add'">Update Guarantee</span>
          <i class="icon-floppy-disk position-right"></i>
        </button>
      </div>
    </div>
  </div>
</form>
<!-- /2 columns form -->



<!-- Vertical form modal -->
<div id="guarantee_modal" class="modal fade" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h5 class="modal-title">Add Guarantee</h5>
      </div>




      <form name="guaranteeForm" [formGroup]="guaranteeForm" novalidate>
        <div class="modal-body">
          <div class="row" *ngIf="ekubSelected() && addUpdateGuarantee">

            <div class="col-md-6">
              <div class="form-group required">
                <span class="control-label">Guarantee Type: </span>
                <!--  <input type="text" name="type" formControlName="type"
                  placeholder="Minimum for award award qualification" class="form-control"> -->
                <select name="type" formControlName="type" class="form-control"
                  data-placeholder="Select guarantee type">
                  <option selected disabled>Status:</option>
                  <option value="member">Member</option>
                  <option value="libre">Libre</option>
                  <option value="carta">Carta</option>
                </select>
                <div class="help-block" *ngIf="type.invalid && (type.dirty || type.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 position-left"></i> Guarantee Type is required
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <span class="control-label"> Guarantee Ref. Number: </span>
                <input type="text" name="guarantee_ref_number" formControlName="guarantee_ref_number"
                  placeholder="Libre/Carta/Member Code Ref. Number" class="form-control">
                <div class="help-block"
                  *ngIf="guarantee_ref_number.invalid && (guarantee_ref_number.dirty || guarantee_ref_number.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 tx-red position-left"></i> Award guarantee type is required
                  </p>
                </div>
              </div>
            </div>

            <div class="col-sm-6" *ngIf="type.value == 'member'">
              <label>Guarantee/User</label>
              <ng-select [items]="users" placeholder="search guarantee user" (change)="fetchUserStats()"
                (keyup)="fetchUser($event)" formControlName="guarantee" bindValue="id" bindLabel="text">
              </ng-select>
              <!--  <input type="text" name="guarantee" formControlName="guarantee" placeholder="Guarantee / ekub user"
                class="form-control"> -->
            </div>

            <div class="form-group">

              <div class="col-sm-6 required">
                <span class="control-label">Status: </span>
                <select name="status" required formControlName="status" class="form-control"
                  data-placeholder="Select ekub status">
                  <option selected disabled>Status:</option>
                  <option value="pending">Pending</option>
                  <option value="active">Active</option>
                  <option value="released">Released</option>
                </select>
                <div class="help-block" *ngIf="status.invalid && (status.dirty || status.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 position-left"></i>Guarantee status is required.
                  </p>
                </div>
              </div>
            </div>

          </div>


          <div class="form-group">
            <div class="row">
              <div class="col-sm-12">
                <label>&nbsp;</label>
                <label>Remark:</label>
                <textarea rows="5" cols="5" class="form-control" required name="remark" formControlName="remark"
                  placeholder="Additional information . . ."></textarea>
              </div>
            </div>
          </div>


          <div *ngIf="type.value == 'libre'">
            <div class="row">
              <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="onFilesAdded($event)">
                <ngx-dropzone-label>
                  <div>
                    <h6 style="color:gray;" translate>- Drop Guarantee Libre Picture here -</h6>
                  </div>
                </ngx-dropzone-label>
                <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f"
                  [removable]="true" (removed)="onRemove(f)">
                </ngx-dropzone-image-preview>
              </div>

            </div><br>
          </div>

          <div *ngIf="type.value == 'carta'">
            <div class="row">
              <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="onFilesAdded($event)">
                <ngx-dropzone-label>
                  <div>
                    <h6 style="color:gray;" translate>- Drop Guarantee Ownership title (Carta) Picture here -</h6>
                  </div>
                </ngx-dropzone-label>
                <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f"
                  [removable]="true" (removed)="onRemove(f)">
                </ngx-dropzone-image-preview>
              </div>

            </div><br>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-dismiss="modal">Cancel</button>
          <button (click)="addGuarantee()" [disabled]="guaranteeForm.invalid" data-dismiss="modal"
            class="btn bg-slate-800">Add Guarantee</button>
        </div>
      </form>


    </div>
  </div>
</div>
<!-- /vertical form modal -->